"use client";

import { VehicleMedia } from "@alba-cars/common-modules";
import { useState } from "react";

import DesktopGallery from "./DesktopGallery";
import GalleryModal from "./GalleryModal";
import MobileSwiper from "./MobileSwiper";
// Temporarily disabled — photos carousel only
// import VerticalVideoModal from "./VerticalVideoModal";
// import { extractVerticalVideo, getImageMedia } from "./videoUtils";
import { getImageMedia } from "./videoUtils";

interface CarGalleryProps {
  altText: string;
  validImages: VehicleMedia[];
  showRamadanBanner?: boolean;
  isReserved?: boolean;
  isCarOfTheDay?: boolean;
  imageObjectFit?: "cover" | "contain";
}

const CarGallery: React.FC<CarGalleryProps> = ({
  altText,
  validImages,
  showRamadanBanner,
  isReserved,
  isCarOfTheDay = false,
  imageObjectFit = "cover",
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalIndex, setModalIndex] = useState(0);
  // Temporarily disabled — photos carousel only
  // const [isVerticalVideoModalOpen, setIsVerticalVideoModalOpen] = useState(false);

  // Temporarily disabled — photos carousel only
  // const verticalVideo = extractVerticalVideo(validImages);
  const imageOnlyMedia = getImageMedia(validImages);
  const modalImages = imageOnlyMedia.length > 0 ? imageOnlyMedia : validImages;

  const openModal = (index: number) => {
    setModalIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <DesktopGallery
        images={validImages}
        altText={altText}
        onImageClickAction={openModal}
        isReserved={isReserved}
        isCarOfTheDay={isCarOfTheDay}
        imageObjectFit={imageObjectFit}
        // Temporarily disabled — photos carousel only
        // hasVerticalVideo={Boolean(verticalVideo)}
        // onVerticalVideoOpenAction={() => setIsVerticalVideoModalOpen(true)}
      />

      <MobileSwiper
        images={validImages}
        altText={altText}
        onImageClick={openModal}
        showRamadanBanner={showRamadanBanner}
        isReserved={isReserved}
        isCarOfTheDay={isCarOfTheDay}
        imageObjectFit={imageObjectFit}
        // Temporarily disabled — photos carousel only
        // hasVerticalVideo={Boolean(verticalVideo)}
        // onVerticalVideoOpenAction={() => setIsVerticalVideoModalOpen(true)}
      />

      <GalleryModal
        isOpen={isModalOpen}
        onClose={closeModal}
        images={modalImages}
        initialSlide={modalIndex}
        altText={altText}
        imageObjectFit={imageObjectFit}
      />

      {/* Temporarily disabled — photos carousel only */}
      {/*
      {verticalVideo?.src && (
        <VerticalVideoModal
          isOpen={isVerticalVideoModalOpen}
          onClose={() => setIsVerticalVideoModalOpen(false)}
          videoSrc={verticalVideo.src}
          poster={imageOnlyMedia[0]?.mediaUrl}
        />
      )}
      */}
    </>
  );
};

export default CarGallery;
